import React, { useCallback, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'

import { styles } from '../../styles'
import { menu, close } from '../../assets'

const Navbar = () => {
  const [active, setActive] = useState('')
  const [toggle, setToggle] = useState(false)

  const navLinks = useMemo(() => [
    { id: 'home', title: 'Home', link: '/#home' },
    { id: 'login', title: 'Login', link: '/login' },
    { id: 'signup', title: 'Sign Up', link: '/signup' },
    { id: 'gallery', title: 'Gallery', link: '/gallery' },
    { id: 'end-user', title: 'End User Agreement', link: '/agreements/end-user' },
    { id: 'privacy-policy', title: 'Privacy Policy', link: '/agreements/privacy-policy' }
  ], [])

  const handleLinkClick = useCallback((title) => {
    setActive(title)
    if (title === '') {
      window.scrollTo(0, 0)
    }
  }, [])

  const handleToggleClick = useCallback(() => {
    setToggle(prevToggle => !prevToggle)
  }, [])

  return (
    <nav
      className={`
        ${styles.paddingX} w-full flex items-center fixed top-0 z-20 bg-primary
      `}
    >
      <div className='w-full flex justify-between items-center max-w-7xl mx-auto'>
        <Link
          to='/'
          className='flex items-center gap-2'
          onClick={() => handleLinkClick('')}
        >
          {/* <img src={logo} alt="logo" className='w-9 h-9 object-contain' /> */}
          <span href='/' className='font-bold cursor-pointer flex'>
            <img
              width={100}
              height={100}
              className='object-contain w-28 h-28 rounded-full'
              src='https://avatars.githubusercontent.com/u/66434496?s=200&v=4'
              alt='Logo'
              loading='lazy'
            />
          </span>

        </Link>
        <ul className='list-none hidden md:flex flex-row gap-5 lg:gap-10'>
          {navLinks.map(link => (
            <li
              key={link.id}
              className={`${
                active === link.title
                  ? 'text-white'
                  : 'text-secondary'
              } hover:text-white text-[18px] font-medium cursor-pointer`}
              onClick={() => handleLinkClick(link.title)}
            >
              <Link to={`${link.link}`}>{link.title}</Link>
            </li>
          ))}
        </ul>

        <div className='md:hidden flex justify-end flex-1 items-center'>
          <img
            src={!toggle ? menu : close}
            alt='menu'
            className='object-contain w-[28px] h-[28px] cursor-pointer'
            onClick={handleToggleClick}
          />
          <div className={`${toggle ? 'flex' : 'hidden'} p-6 blackGradient absolute top-20 right-0 mx-4 my-2 min-w-[140px] z-10 rounded-xl`}>
            <ul className='list-none flex flex-col gap-4 justify-end items-start'>
              {navLinks.map(link => (
                <li
                  key={link.id}
                  className={`${
                    active === link.title
                      ? 'text-white'
                      : 'text-secondary'
                  } font-poppins font-medium cursor-pointer text-[16px]`}
                  onClick={() => {
                    handleLinkClick(link.title)
                    handleToggleClick()
                  }}
                >
                  <Link to={`${link.link}`}>{link.title}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
